






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class AgeConfirmation extends Vue {
  dialog = false;
  open(): void {
    this.dialog = true;
  }
  close(): void {
    this.dialog = false;
  }
  externalLink(): void {
    const url = "https://www.google.co.jp/";
    window.location.href = url;
  }
}
